export default __webpack_public_path__ + "static/media/294.d463d8b2.jpg";